<template>
  <v-sheet
    class="trns blue darken-3 sidebar"
    :class="{
      hidden: ($vuetify.breakpoint.sm || $vuetify.breakpoint.xs) && expand,
      floatover: ($vuetify.breakpoint.sm || $vuetify.breakpoint.xs) && !expand,
    }"
    elevation="0"
    dark
  >
    <div
      id="closeBtn"
      :class="{
        mobile: ($vuetify.breakpoint.sm || $vuetify.breakpoint.xs) && expand,
      }"
    >
      <!-- <Tooltip :content="expand ? 'Open' : 'Close'" color="info" right top> -->
      <v-icon
        size="20"
        @click="toggleExpand"
        :title="expand ? 'Open' : 'Close'"
      >
        mdi-chevron-{{ expand ? "right" : "left" }}
      </v-icon>
      <!-- </Tooltip> -->
    </div>
    <v-row
      v-if="(!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs) || !expand"
      class="ma-0 justify-center"
    >
      <img class="icon" src="../assets/pine3_logo_white.svg" alt="Pine3" />
    </v-row>
    <v-row
      v-if="(!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs) || !expand"
      class="ma-1 justify-center"
    >
      <h6 v-if="!expand" class="iconFont">Automation made simple</h6>
    </v-row>
    <!-- <v-list dense dark class="trns">
      <v-subheader>Services</v-subheader> -->
    <!-- <v-list-item-group>
        <v-list-item
          v-for="(item, i) in services"
          :key="i"
          :to="item.link"
          v-show="item.role >= role"
          :ripple="false"
          class="px-5"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon">
</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="!expand">
            <v-list-item-title
              v-text="item.text"
              class="px-2 py-1 itemText"
            >
</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list> -->
    <section
      v-if="(!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs) || !expand"
    >
      <v-row v-for="(list, i) in items" :key="i">
        <v-col>
          <v-list dense dark class="trns" v-if="role <= list.role">
            <v-subheader v-if="list.name" class="text-capitalize">
              <v-icon v-if="!expand" class="mr-2" x-small>
                mdi-{{ getIcon(list.icon) }}
              </v-icon>
              <strong>{{ list.name }}</strong>
            </v-subheader>
            <v-list-item-group>
              <v-list-item
                v-for="(item, i) in list.menu"
                :key="i"
                router-link-exact-active
                :to="item.link"
                v-show="item.role >= role"
                :ripple="false"
              >
                <v-list-item-icon>
                  <v-icon>mdi-{{ getIcon(item.icon) }} </v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="!expand">
                  <v-list-item-title class="px-4 py-1 itemText">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-badge v-if="item.badge" color="error" dark right origin>
                  <template slot="badge">
                    <strong>
                      {{ item.badge }}
                    </strong>
                  </template>
                </v-badge>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </section>
  </v-sheet>
</template>

<script lang="ts">
import { RoleType, User } from "@/types";
import { viewIcon } from "@/utils";
import Vue from "vue";

export default Vue.extend({
  name: "SideBar",
  data() {
    return {};
  },
  methods: {
    toggleExpand() {
      this.$store.commit("toggleExpand");
    },
    getIcon(icon: string) {
      return viewIcon[icon];
    },
  },
  computed: {
    role() {
      return this.$store.getters["Users/getRole"];
    },
    user(): User {
      return this.$store.getters["Users/getUser"];
    },
    expand() {
      return this.$store.getters.getDisplayExpand;
    },
    items() {
      const items = [
        {
          name: "",
          menu: [
            {
              text: "Dashboard",
              link: "/",
              icon: "dashboard",
              role: RoleType.USER,
              badge: "",
            },
            {
              text: "Test Cases",
              link: "/plans",
              icon: "plans",
              role: RoleType.USER,
              badge: "",
            },
            {
              text: "Routines",
              link: "/routines",
              icon: "routines",
              role: RoleType.USER,
            },
            {
              text: "Templates",
              link: "/templates",
              icon: "templates",
              role: RoleType.SUPER_ADMIN,
              badge: "new",
            },
            {
              text: "Results",
              link: "/results",
              icon: "results",
              role: RoleType.USER,
              badge: "",
            },
            {
              text: "Test Suites",
              link: "/suites",
              icon: "suites",
              role: RoleType.USER,
              badge: "",
            },
            {
              text: "Scheduler",
              link: "/scheduler",
              icon: "scheduler",
              role: RoleType.USER,
              badge: "",
            },
            // {
            {
              text: "API Integrations",
              link: "/keys",
              icon: "keys",
              role: RoleType.ADMIN,
              badge: "",
            },
            {
              text: "Knowledge Center",
              link: "/learn",
              icon: "learn",
              role: RoleType.USER,
              badge: "",
            },
          ],
          role: RoleType.USER,
        },
        {
          name: "settings",
          menu: [
            {
              text: "Groups",
              link: "/groups",
              icon: "group",
              role: RoleType.SUPER_ADMIN,
              badge: "",
            },
            {
              text: "Users",
              link: "/users",
              icon: "users",
              role: RoleType.ADMIN,
              badge: "",
              exact: true,
            },
            // {
            //   text: "Group Settings",
            //   //   link: `/group/settings/${this.user.group}`,
            //   icon   link: `/group/settings/${this.user.group}`,
            //   role: RoleType.ADMIN,
            //   badge: "",
            // },
            {
              text: "User Preferences",
              link: "/preferences",
              icon: "preferences",
              role: RoleType.USER,
              badge: "",
            },
          ],
          role: RoleType.USER,
          icon: "settings",
        },
      ];
      return items;
    },
  },
  created() {
    this.$store.commit("setExpand");
    this.$store.dispatch("Users/getRole");
  },
});
</script>

<style scoped>
.sidebar {
  height: 100%;
}
.floatover {
  position: absolute;
  left: 0;
  z-index: 200;
}
.v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 0;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0;
}
.itemText {
  font-size: 16px !important;
}
.v-subheader {
  background-color: transparent !important;
}
.icon {
  width: 50px;
  margin-top: 5px;
  /* margin-left: 5px; */
}
.iconFont {
  font-weight: 100;
  font-size: 14px;
  display: block;
  /* position: absolute;
  left: 70px;
  bottom: -1px; */
}
#closeBtn {
  position: relative;
  width: 100%;
}
#closeBtn .v-icon,
.mobile .v-icon {
  position: absolute;
  right: -10px;
  top: 3px;
  border-radius: 100%;
  border: 2px solid #2d66c0;
  color: #2d66c0;
  background-color: #fff;
  z-index: 100;
}
.mobile .v-icon {
  right: -30px !important;
}
.v-list {
  padding: 0;
}
.v-subheader {
  font-size: 12px !important;
  height: 20px !important;
  color: #fff !important;
  /* border-bottom: 1px solid rgba(0, 128, 128, 0.212);
  border-top: 1px solid rgba(0, 128, 128, 0.212); */
}
</style>
